/**
 * Create Product Groups context for custom hook
 */
import { createContext } from 'react'

const StoredValueTransactionsContext = createContext({
  fetchStoredValueTransactions: () => {},
})

export default StoredValueTransactionsContext
